import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '適用コンテンツ',

  // 選択サービス名
  serviceName: null,

  // model
  contentsSettingModel: [],
  contentsApplyModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {contentsSettingParams}) {
    console.log('contentsSettingParams', contentsSettingParams)
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsSettingListGet'],
        [contentsSettingParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceName', res[0].data.serviceName)
            commit('setContentsSettingModel', res[0].data.serviceContentsSettings)
            console.log('contentsSettingModel', state.contentsSettingModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          console.log(error)
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 適用コンテンツデータを読出し
   */
  loadContentsApplyList ({commit}, {contentsApplyParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceContentsApply'],
        ['v1ServiceContentsApplyListGet'],
        [contentsApplyParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setContentsApplyModel', res[0].data.serviceAppliedContents)
            console.log('contentsApplyModel', state.contentsApplyModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },
  // model
  setContentsSettingModel (state, data) {
    Vue.set(state, 'contentsSettingModel', data)
  },
  setContentsApplyModel (state, data) {
    data.sort(Utility.sortByKey('priorityOrder', true))
    Vue.set(state, 'contentsApplyModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
